import { Component, OnInit } from '@angular/core';
import { AdminService } from 'src/app/services/Admin/admin.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-class-teacher-access-map',
  templateUrl: './class-teacher-access-map.component.html',
  styleUrls: ['./class-teacher-access-map.component.css']
})
export class ClassTeacherAccessMapComponent implements OnInit {

  ClassTeacherAccessMapList=[];
  StaffList=[];
  Count1=0;
  Submitted=false;

  constructor(private adminservice: AdminService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  ClassTeacherAccessMapModel = {
    StaffID: 0,
    IsActive: false
}

ValidState(){
  return this.ClassTeacherAccessMapModel.StaffID==0;
}
SaveClassTeacherAccessMap(valid) {
  this.Submitted=true;
  if(valid && !this.ValidState()){
   this.spinnerService.show();
    this.adminservice.SaveClassTeacherAccessMap(JSON.stringify(this.ClassTeacherAccessMapList),this.ClassTeacherAccessMapModel.StaffID).subscribe((data: any) => {
           this.spinnerService.hide();
           this.Submitted=false;
            this.GetClassTeacherAccessMap();
            this.globalHelper.CheckActionStatus(data);
        });
      }
};

GetClassTeacherAccessMap() {
  this.Submitted=false;
   this.spinnerService.show();
    this.adminservice.GetClassTeacherAccessMap(this.ClassTeacherAccessMapModel.StaffID).subscribe((data: any) => {
        this.ClassTeacherAccessMapList = data.ClassTeacherAccessMapList;
        this.spinnerService.hide();
    });
};

  ngOnInit() {
    this.GetTeacher();
  }

  
GetTeacher() {
  this.lookupservice.GetLookupsList('StaffNameNotClassTeacher', '').subscribe((data: any) => {
      this.StaffList = data.LookupItems;
  });
};


SelectModel = {
  IsSelect:false,
  IsActive:false,

}
SelectAll() {

    if (this.SelectModel.IsSelect) {
        for (var i = 0; i < this.ClassTeacherAccessMapList.length; i++) {
            this.ClassTeacherAccessMapList[i].IsActive = true;
        }
    }
    if (this.SelectModel.IsSelect == false) {
        for (var i = 0; i < this.ClassTeacherAccessMapList.length; i++) {
            this.ClassTeacherAccessMapList[i].IsActive = false;

        }
    }

}
ChangeSelect(item) {
    this.Count1 = 0;

    for (var i = 0; i < this.ClassTeacherAccessMapList.length; i++) {
        if (this.ClassTeacherAccessMapList[i].Active) {
            this.Count1 = this.Count1 + 1

        }
    }


    if (this.Count1 == this.ClassTeacherAccessMapList.length) {
        this.SelectModel.IsSelect = true;

    }
    else {
        this.SelectModel.IsSelect = false;
    }

}

}
